import React from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { useNavigate, useLocation } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";

const StateUser = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    
    // Basic user information
    const [userNameValue, setUserNameValue] = useState("");
    const [mobileValue, setMobileValue] = useState("");
    const [emailValue, setEmailValue] = useState("");
    const [designationValue, setDesignationValue] = useState("");
    const [gender, setGender] = useState('');
    const [userCodeLocal, setUserCodeLocal] = useState("");
    const [userLevelValue, setUserLevelValue] = useState("");
    const [userRoleValue, setUserRoleValue] = useState("");
    
    // KVK, State and District related
    const [kvkValue, setKvkValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [districtValue, setDistrictValue] = useState([]);  // Changed to array for multiple selection
    const [blockValue, setBlockValue] = useState([]); // Changed to array for multiple selection
    const [districtOptions, setDistrictOptions] = useState([]);
    const [blockOptions, setBlockOptions] = useState([]);
    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [selectedBlocks, setSelectedBlocks] = useState([]);
    const [subDistrictValue, setSubDistrictValue] = useState("");
    const [selected, setSelected] = useState([]);
   
    // Data arrays
    const [kvkData, setKvkData] = useState([]);
    const [statesData, setStatesData] = useState([]);
    const [districtsData, setDistrictsData] = useState([]);
    const [blocksData, setBlocksData] = useState([]);
    const [designationData, setDesignationData] = useState([]);
    
    // Validation and UI states
    const [isStateAutoSelected, setIsStateAutoSelected] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    // Add new state for select all toggles
    const [selectAllDistricts, setSelectAllDistricts] = useState(false);
    const [selectAllBlocks, setSelectAllBlocks] = useState(false);

    useEffect(() => {
        // Don't auto-fill user name - let user enter it manually
        // Only set user name in edit mode from the state object, not from session storage
        
        fetchDesignation();
      
        fetchStates();
    }, []);

    // Auto-fill state based on session storage after states are loaded
    useEffect(() => {
        if (statesData.length > 0 && !state) {
            // Get state code and state name from session storage
            const sessionStateCode = sessionStorage.getItem("stateNameModel");
            const sessionStateName = sessionStorage.getItem("stateNameModel");
          //  alert(sessionStorage.getItem("userTypeCodeModel"));
            console.log("Session Storage Values:", {
                stateCode: sessionStateCode,
                stateName: sessionStateName
            });
            
            if (sessionStateCode && sessionStateCode !== "0" && sessionStateCode !== "null") {
                console.log("Auto-filling state based on session storage. State Code:", sessionStateCode);
                
                // Find the matching state in the loaded states data
                let matchingState = statesData.find(stateItem => 
                    stateItem.stateCode === sessionStateCode || 
                    stateItem.stateCode === Number(sessionStateCode)
                );
                
                // If no match by code but we have a state name, try to find by name as fallback
                if (!matchingState && sessionStateName && sessionStateName !== "null") {
                    console.log("No match by code, trying to match by state name:", sessionStateName);
                    matchingState = statesData.find(stateItem => 
                        stateItem.stateName.toLowerCase() === sessionStateName.toLowerCase()
                    );
                }
                
                if (matchingState) {
                    console.log("Found matching state:", matchingState.stateName, "with code:", matchingState.stateCode);
                    setStateValue(matchingState.stateCode.toString());
                    setIsStateAutoSelected(true); // Mark state as auto-selected
                    
                    // Update session storage with the correct values if needed
                    if (!sessionStorage.getItem("stateNameModel") || sessionStorage.getItem("stateNameModel") === "null") {
                        sessionStorage.setItem("stateNameModel", matchingState.stateName);
                        console.log("Updated session storage with state name:", matchingState.stateName);
                    }
                } else {
                    console.log("No matching state found for code:", sessionStateCode, "or name:", sessionStateName);
                }
            }
        }
    }, [statesData, state]);

    // Populate User Level dropdown options for state users
    useEffect(() => {
        const x = document.getElementById("userType");
        
        if (!x) return;
        
        // Clear existing options except the first one (Choose...)
        while (x.options.length > 1) {
            x.remove(1);
        }
        
        // Helper to add options
        const addOption = (text, value) => {
            const option = document.createElement("option");
            option.text = text;
            option.value = value;
            x.add(option);
        };

        // State users can create District, Block, and Surveyor users
        addOption("District", "3");
        //addOption("Block", "4");
        addOption("Surveyor", "5");
        
    }, []);

    useEffect(() => {
        // useEffect to set defaultValue in dropdown menu for edit mode
        if (state) {
            console.log("Edit mode - setting default values from state:", state);
            
            setUserLevelValue(state.cropSurveyCode.userTypeCode);
            setStateValue(state.cropSurveyCode.stateCode);
            setDistrictValue(state.cropSurveyCode.districtCode);
            setBlockValue(state.cropSurveyCode.blockCode || "");
            setSubDistrictValue(state.cropSurveyCode.subDistrictCode || "");
            setUserNameValue(state.cropSurveyCode.userName);
            setMobileValue(state.cropSurveyCode.mobile);
            setEmailValue(state.cropSurveyCode.emailId);
            setDesignationValue(state.cropSurveyCode.designationCode);
            setUserCodeLocal(state.cropSurveyCode.userCode);
            setGender(state.cropSurveyCode.gender);
            
            // Set user role for edit mode based on user type
            const userType = state.cropSurveyCode.userRoleCode;
            switch(userType) {
                case "3":
                    setUserRoleValue("District");
                    break;
                case "4":
                    setUserRoleValue("Block");
                    break;
                case "5":
                    setUserRoleValue("Surveyor");
                    break;
                
            }
            
            // Fetch districts for the selected state
            if (state.cropSurveyCode.stateCode) {
                fetchDistricts(state.cropSurveyCode.stateCode);
            }
            
            // Fetch blocks for the selected district
            if (state.cropSurveyCode.districtCode && state.cropSurveyCode.userTypeCode >= 4) {
                fetchBlocks(state.cropSurveyCode.districtCode);
            }
        }
    }, []);

    // Validation functions
    const validateField = (fieldName, value) => {
        const errors = { ...validationErrors };
        
        switch (fieldName) {
           
                
            case 'state':
                if (!value || value === "NA") {
                    errors.state = "Please select a State";
                } else {
                    delete errors.state;
                }
                break;
                
            case 'district':
                if (!value || value.length === 0) {
                    errors.district = "Please select at least one District";
                } else {
                    delete errors.district;
                }
                break;
                
            case 'block':
                if (userLevelValue === "5" && (!value || value.length === 0)) {
                    errors.block = "Please select at least one Block";
                } else {
                    delete errors.block;
                }
                break;
                
            case 'userName':
                if (!value || value.trim() === "") {
                    errors.userName = "Please enter a valid user name";
                } else {
                    delete errors.userName;
                }
                break;
                
            case 'designation':
                if (!value || value === "Choose..." || value === "") {
                    errors.designation = "Please select a designation";
                } else {
                    delete errors.designation;
                }
                break;
                
            case 'mobile':
                if (!value || value.length !== 10) {
                    errors.mobile = "Please enter a valid 10-digit mobile number";
                } else {
                    delete errors.mobile;
                }
                break;
                 case 'email':
                if (!value || value.length === 0 || !validateEmail(value)) {
                    errors.emailid = "Please enter a valid email ID";
                } else {
                    delete errors.emailid;
                }
                break;
                
            case 'gender':
                if (!value) {
                    errors.gender = "Please select a gender";
                } else {
                    delete errors.gender;
                }
                break;
                
            case 'email':
                if (value && !validateEmail(value)) {
                    errors.email = "Please enter a valid email address";
                } else {
                    delete errors.email;
                }
                break;
                
            case 'userRole':
                if (!value || value === "Choose..." || value === "") {
                    errors.userRole = "Please select a user role";
                } else {
                    delete errors.userRole;
                }
                break;
                
            default:
                break;
        }
        
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateAllFields = () => {
        const fieldsToValidate = [
            { name: 'state', value: stateValue },
            { name: 'district', value: districtValue },
            { name: 'userName', value: userNameValue },
            { name: 'designation', value: designationValue },
            { name: 'mobile', value: mobileValue },
            { name: 'gender', value: gender },
            { name: 'email', value: emailValue },
            { name: 'userRole', value: userRoleValue }
        ];

        // Add block validation only for Surveyor user level
        if (userLevelValue === "5") {
            fieldsToValidate.push({ name: 'block', value: blockValue });
        }
        
        let isValid = true;
        fieldsToValidate.forEach(field => {
            const fieldValid = validateField(field.name, field.value);
            if (!fieldValid) isValid = false;
        });
        
        return isValid;
    };

    useEffect(() => {
        if (stateValue && stateValue !== "NA") {
            console.log("State selected:", stateValue, "- Fetching districts...");
            fetchDistricts(stateValue);
        } else {
            console.log("No state selected or state is NA, clearing districts");
            setDistrictsData([]);
            setDistrictValue([]);
        }
    }, [stateValue]);



    const fetchDesignation = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/Management/commDesignation`
            );
            setDesignationData(result.data.dataContent);
        } catch (error) {
            console.error("Error fetching designations:", error);
        }
    };

    

    const fetchStates = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            // Show all states
            const allStates = result.data.dataContent;
            console.log("All states:", allStates);
            setStatesData(allStates);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const fetchDistricts = async (stateCode) => {
        try {
            console.log("Fetching districts for state code:", stateCode);
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: Number(stateCode),
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/district`,
                requestOptions
            );
            
            const result = await response.text();
            const jsonResult = JSON.parse(result);
            console.log("Districts API response:", jsonResult);
            
            if (jsonResult && jsonResult.dataContent) {
                setDistrictsData(jsonResult.dataContent);
                // Format districts data for MultiSelect
                const formattedDistricts = jsonResult.dataContent.map(district => ({
                    label: district.districtName,
                    value: district.districtCode.toString()
                }));
                setDistrictOptions(formattedDistricts);
            }
        } catch (error) {
            console.error("Error fetching districts:", error);
            setDistrictsData([]);
            alert("Error loading districts. Please try again.");
        }
    };

    // Modify fetchBlocks to accumulate blocks instead of replacing them
    const fetchBlocks = async (districtCode) => {
        try {
            console.log("Fetching blocks for district code:", districtCode);
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                blockCode: 0,
                blockName: "",
                subDistrictCode: 0,
                districtCode: Number(districtCode),
                visibility: 1
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/block`,
                requestOptions
            );
            
            const result = await response.text();
            const jsonResult = JSON.parse(result);
            
            if (jsonResult && jsonResult.dataContent) {
                // Format blocks data for MultiSelect
                const newBlocks = jsonResult.dataContent.map(block => ({
                    label: block.blockName,
                    value: block.blockCode.toString(),
                    districtCode: block.districtCode.toString()
                }));
                
                // Merge with existing blocks, removing duplicates
                setBlockOptions(prevBlocks => {
                    const existingBlockCodes = new Set(prevBlocks.map(b => b.value));
                    const uniqueNewBlocks = newBlocks.filter(b => !existingBlockCodes.has(b.value));
                    return [...prevBlocks, ...uniqueNewBlocks];
                });
            }
        } catch (error) {
            console.error("Error fetching blocks:", error);
            alert("Error loading blocks. Please try again.");
        }
    };

    function ValidateAddUser() {
        console.log("ValidateAddUser function called");
        
        try {
            // Clear previous validation errors
            setValidationErrors({});
            
            // Validate all fields and collect errors
            const fieldsToValidate = [
                { name: 'state', value: stateValue },
                { name: 'district', value: districtValue },
                { name: 'userName', value: userNameValue },
                { name: 'designation', value: designationValue },
                { name: 'mobile', value: mobileValue },
                { name: 'gender', value: gender },
                { name: 'email', value: emailValue },
                { name: 'userRole', value: userRoleValue }
            ];

            // Add block validation only for Surveyor user level
            if (userLevelValue === "5") {
                fieldsToValidate.push({ name: 'block', value: blockValue });
            }
            
            let errors = {};
            let isValid = true;
            
            fieldsToValidate.forEach(field => {
                const fieldErrors = validateFieldSync(field.name, field.value);
                if (Object.keys(fieldErrors).length > 0) {
                    errors = { ...errors, ...fieldErrors };
                    isValid = false;
                }
            });
            
            // Additional validation
            if (!userLevelValue || userLevelValue === "") {
                errors.userLevel = "Please select a user level";
                isValid = false;
            }
            
            // Update validation errors state
            setValidationErrors(errors);
            
            if (!isValid) {
                // Find the first error and show it
                const firstError = Object.values(errors)[0];
                if (firstError) {
                    alert(firstError);
                }
                return;
            }

            console.log("Validation successful, calling", state ? "UpdateUser" : "AddNewUser");
            state ? UpdateUser() : AddNewUser();
        } catch (error) {
            console.error("Error in ValidateAddUser:", error);
            alert("An error occurred during validation. Please check console for details.");
        }
    }

    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Synchronous validation function that returns errors instead of updating state
    const validateFieldSync = (fieldName, value) => {
        const errors = {};
        
        switch (fieldName) {
            case 'userLevel':
                if (!value || value === "") {
                    errors.userLevel = "Please select a user level";
                }
                break;
                
            case 'state':
                if (!value || value === "NA") {
                    errors.state = "Please select a State";
                } else if (!statesData.some(state => state.stateCode.toString() === value.toString())) {
                    errors.state = "Please select a valid state";
                }
                break;
                
            case 'district':
                if (!value || value.length === 0) {
                    errors.district = "Please select at least one District";
                } else if (!value.every(districtCode => districtsData.some(d => d.districtCode.toString() === districtCode.toString()))) {
                    errors.district = "Please select valid districts";
                }
                break;
                
            case 'block':
                if (userLevelValue === "5" && (!value || value.length === 0)) {
                    errors.block = "Please select at least one Block";
                } else if (userLevelValue === "5" && value && value.length > 0 && !value.every(blockCode => blockOptions.some(b => b.value === blockCode.toString()))) {
                    errors.block = "Please select valid blocks";
                }
                break;
                
            case 'userName':
                if (!value || value.trim() === "") {
                    errors.userName = "Please enter a valid user name";
                } else if (value.trim().length < 3) {
                    errors.userName = "User name must be at least 3 characters long";
                } else if (value.trim().length > 50) {
                    errors.userName = "User name cannot exceed 50 characters";
                } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
                    errors.userName = "User name can only contain letters and spaces";
                }
                break;
                
            case 'designation':
                if (!value || value === "Choose..." || value === "") {
                    errors.designation = "Please select a designation";
                } else if (!designationData.some(desig => desig.desigCode.toString() === value.toString())) {
                    errors.designation = "Please select a valid designation";
                }
                break;
                
            case 'email':
                if (!value || value.length === 0 || !validateEmail(value)) {
                    errors.email = "Please enter a valid email address";
                } else {
                    delete errors.email;
                }
                break;

            case 'mobile':
                if (!value) {
                    errors.mobile = "Please enter a valid 10-digit mobile number";
                } else if (value.length !== 10) {
                    errors.mobile = "Please enter a valid 10-digit mobile number";
                } else if (!/^[6-9]\d{9}$/.test(value)) {
                    errors.mobile = "Please enter a valid Indian mobile number";
                }
                break;
                
            case 'gender':
                if (!value) {
                    errors.gender = "Please select a gender";
                } else if (!["M", "F", "T"].includes(value)) {
                    errors.gender = "Please select a valid gender";
                }
                break;
                
            case 'email':
                if (value && !validateEmail(value)) {
                    errors.email = "Please enter a valid email address";
                } else if (value && value.length > 100) {
                    errors.email = "Email cannot exceed 100 characters";
                }
                break;
                
            case 'userRole':
                if (!value || value === "Choose..." || value === "") {
                    errors.userRole = "Please select a user role";
                }
                break;
                
            default:
                break;
        }
        
        return errors;
    };

    function AddNewUser() {
        console.log("AddNewUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();
            
            // Create payload for district user
            const payload = {
                "createdOnByUC": currentDate,
                "createdByUC": Number(sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": currentDate,
                "modifiedByUC": Number(sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel")),
                "userRoleCode": getRoleCodeFromUserLevel(userLevelValue),
                "userCode": 0,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": String(stateValue),
                "districtCode": districtValue.join(','), // Join multiple district codes
                "subDistrictCode": "",
                "blockCode": blockValue.length > 0 ? blockValue.join(',') : "0", // Join multiple block codes
                "villageCode": "",
                "userTypeCode": sessionStorage.getItem("userTypeCodeModel"),// String(userLevelValue),
                "schemeCode": sessionStorage.getItem("schemeCodeModel") || "16",
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": 0,
                "fmtcCode": 0,
                "atariCode": 0,
                "kvkCode": 0
            };
            
            console.log("API Payload:", payload);
            var raw = JSON.stringify(payload);

            var requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: raw,
              redirect: "follow",
            };

            const apiUrl = `${
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
            }/api/MT/Users`;
            console.log("Sending API request to:", apiUrl);
            
            fetch(
              apiUrl,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    
                    if (jsonResult.success === true) {
                        alert("User created successfully!");
                        console.log("User created successfully, navigating to user list");
                        navigate("/MNT/UsrListMnt");
                    } else {
                        // Handle specific error messages
                        let errorMessage = "Failed to create user.";
                        
                        if (jsonResult.message) {
                            if (jsonResult.message.includes("Mobile already exist")) {
                                errorMessage = "A user with this mobile number already exists. Please use a different mobile number.";
                            } else if (jsonResult.message.includes("Email already exist")) {
                                errorMessage = "A user with this email address already exists. Please use a different email address.";
                            } else if (jsonResult.message.includes("User already exist")) {
                                errorMessage = "A user with this information already exists. Please check the details and try again.";
                            } else {
                                errorMessage = jsonResult.message;
                            }
                        }
                        
                        alert(errorMessage);
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response. Please try again.");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                if (error.message === "Failed to fetch") {
                    alert("Unable to connect to server. Please check your internet connection and try again.");
                } else {
                    alert("Error communicating with server: " + error.message);
                }
              });
        } catch (error) {
            console.error("Error in AddNewUser:", error);
            alert("An error occurred while creating user. Please check console for details.");
        }
    }

    function UpdateUser() {
        console.log("UpdateUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

             // Create payload for district user
            const payload = {
                "createdOnByUC": currentDate,
                "createdByUC": Number(sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": currentDate,
                "modifiedByUC": Number(sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel")),
                "userRoleCode": getRoleCodeFromUserLevel(userLevelValue),
                "userCode": 0,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": String(stateValue),
                "districtCode": districtValue.join(','), // Join multiple district codes
                "subDistrictCode": "",
                "blockCode": blockValue.length > 0 ? blockValue.join(',') : "0", // Join multiple block codes
                "villageCode": "",
                "userTypeCode": sessionStorage.getItem("userTypeCodeModel"),//String(userLevelValue),
                "schemeCode": sessionStorage.getItem("schemeCodeModel") || "16",
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": 0,
                "fmtcCode": 0,
                "atariCode": 0,
                "kvkCode": 0
            };
            
            console.log("API Payload for update:", payload);
            var raw2 = JSON.stringify(payload);

            var requestOptions = {
              method: "PUT",
              headers: myHeaders,
              body: raw2,
              redirect: "follow",
            };

            const apiUrl = `${
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
            }/api/MT/Users`;
            console.log("Sending API request to update user:", apiUrl);
            
            fetch(
              apiUrl,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    
                    if (jsonResult.success === true) {
                        alert("User updated successfully!");
                        console.log("User updated successfully, navigating to user list");
                        navigate("/MNT/UsrListMnt");
                    } else {
                        // Handle specific error messages
                        let errorMessage = "Failed to update user.";
                        
                        if (jsonResult.message) {
                            if (jsonResult.message.includes("Mobile already exist")) {
                                errorMessage = "A user with this mobile number already exists. Please use a different mobile number.";
                            } else if (jsonResult.message.includes("Email already exist")) {
                                errorMessage = "A user with this email address already exists. Please use a different email address.";
                            } else if (jsonResult.message.includes("User already exist")) {
                                errorMessage = "A user with this information already exists. Please check the details and try again.";
                            } else {
                                errorMessage = jsonResult.message;
                            }
                        }
                        
                        alert(errorMessage);
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response. Please try again.");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                if (error.message === "Failed to fetch") {
                    alert("Unable to connect to server. Please check your internet connection and try again.");
                } else {
                    alert("Error communicating with server: " + error.message);
                }
              });
        } catch (error) {
            console.error("Error in UpdateUser:", error);
            alert("An error occurred while updating user. Please check console for details.");
        }
    }
        function handleUserLevel(value) {
        console.log("setUserLevelValue@@", value)
        
        // Reset role data and value
        setUserRoleValue("")
        setUserLevelValue(value)
        
        // Clear district and block selections when changing user level
        setDistrictValue([]);
        setSelectedDistricts([]);
        setBlockValue([]);
        setSelectedBlocks([]);
        setBlockOptions([]);
        
        // Set role based on user level
        if (value && value !== "Choose...") {
            switch(value) {
                case "3":
                    setUserRoleValue("District");
                    break;
                case "5":
                    setUserRoleValue("Surveyor");
                    break;
                
            }
        }
    }

    // Helper function to get role code based on user level
    function getRoleCodeFromUserLevel(userLevel) {
        switch(userLevel) {
            case "3":
                return "3"; // District role code
            case "5":
                return "5"; // Surveyor role code
            
        }
    }

    function handleUserName(e) {
      let localText = e.target.value.replace(/[^\w\s]/gi, "")
      console.log("Setting userName to:", localText);
      setUserNameValue(localText);
      validateField('userName', localText);
    }

    function handleEmail(e) {
        const emailValue = e.target.value;
        setEmailValue(emailValue);
        validateField('email', emailValue);
    }

    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal);
        validateField('mobile', valueFinal);
    }

    function validateMobile() {
       if (mobileValue.length === 10) {
          document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
          document.getElementById("mobilenumber").style.borderColor = "red";
        }
        validateField('mobile', mobileValue);
    }

    // New handlers with validation
    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        setStateValue(selectedState);
        validateField('state', selectedState);
    };
   
    // Add handler for district selection
    const handleDistrictChange = (selected) => {
        setSelectedDistricts(selected);
        setDistrictValue(selected.map(item => item.value));
        
        // Clear blocks when districts change
        setSelectedBlocks([]);
        setBlockValue([]);
        
        // Fetch blocks for newly selected districts
        selected.forEach(district => {
            fetchBlocks(district.value);
        });
        
        validateField('district', selected);
    };

    // Add handler for block selection
    const handleBlockChange = (selected) => {
        setSelectedBlocks(selected);
        setBlockValue(selected.map(item => item.value));
        validateField('block', selected);
    };

    const handleDesignationChange = (e) => {
        const selectedDesignation = e.target.value;
        setDesignationValue(selectedDesignation);
        validateField('designation', selectedDesignation);
    };

    const handleKvkChange = (e) => {
        const selectedKvk = e.target.value;
        setKvkValue(selectedKvk);
        validateField('kvk', selectedKvk);
    };

    const handleGenderChange = (selectedGender) => {
        setGender(selectedGender);
        validateField('gender', selectedGender);
    };

    // Add new handlers for select all functionality
    const handleSelectAllDistricts = (e) => {
        const isChecked = e.target.checked;
        setSelectAllDistricts(isChecked);
        
        const newSelectedDistricts = {};
        const newDistrictValues = [];
        
        districtsData.forEach(district => {
            newSelectedDistricts[district.districtCode] = isChecked;
            if (isChecked) {
                newDistrictValues.push(district.districtCode);
                // Fetch blocks for each selected district
                fetchBlocks(district.districtCode);
            }
        });
        
        setSelectedDistricts(newSelectedDistricts);
        setDistrictValue(newDistrictValues);
        
        // If unchecking all districts, clear blocks
        if (!isChecked) {
            setBlockValue([]);
            setSelectedBlocks({});
            setSelectAllBlocks(false);
        }
        
        validateField('district', newDistrictValues);
    };

    const handleSelectAllBlocks = (e) => {
        const isChecked = e.target.checked;
        setSelectAllBlocks(isChecked);
        
        const newSelectedBlocks = {};
        const newBlockValues = [];
        
        blocksData.forEach(block => {
            // Only select blocks from selected districts
            if (districtValue.includes(block.districtCode.toString())) {
                newSelectedBlocks[block.blockCode] = isChecked;
                if (isChecked) {
                    newBlockValues.push(block.blockCode);
                }
            }
        });
        
        setSelectedBlocks(newSelectedBlocks);
        setBlockValue(newBlockValues);
        
        validateField('block', newBlockValues);
    };

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarMnt /> 
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>State User</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">State User</li>
                            <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                            <li className="breadcrumb-item">
                                {(() => {
                                    const userTypeCode = Number(sessionStorage.getItem("userTypeCodeModel"));
                                    switch(userTypeCode) {
                                        case 1: return "FMTTI";
                                        case 2: return "CRM";
                                        case 3: return "SMAM";
                                        default: return "";
                                    }
                                })()}
                            </li>
                        </ol>
                    </nav>
                </div>

                <section className="section dashboard newAdminForms">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        
                                    <div className='col-md-4'>
                                        {/* User Level */}
                                        <label className="form-label">User Level</label><label style={{color : "red"}}>*</label>
                                        <select 
                                            className='form-select' 
                                            onChange={(e) => handleUserLevel(e.target.value)} 
                                            value={userLevelValue} 
                                            id="userType" 
                                            disabled={state ? true : false}
                                        >
                                            <option>Choose...</option>
                                            <option value="3">District</option>
                                            <option value="5">Surveyor</option>
                                        </select>
                                    </div>

                                        {/* Role - Show when User Level is selected */}
                                        {userLevelValue && userLevelValue !== "Choose..." && (
                                            <div className="col-md-4">
                                                <label className="form-label">Role</label><label style={{color : "red"}}>*</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={userRoleValue}
                                                    disabled
                                                />
                                            </div>
                                        )}
                                       
                                        
                                        {/* State Name */}
                                        {(userLevelValue >= 3) && (
                                            <div className='col-md-4'>
                                                <label className="form-label">State Name</label><label style={{color : "red"}}>*</label>
                                                <select 
                                                    className={`form-select ${validationErrors.state ? 'is-invalid' : ''}`}
                                                    value={stateValue}
                                                    onChange={handleStateChange}
                                                    disabled={isStateAutoSelected}
                                                    style={isStateAutoSelected ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
                                                > 
                                                    <option value={"NA"}>Choose...</option>
                                                    {statesData.map((item, id) => (
                                                        <option key={id} value={item.stateCode}>
                                                            {item.stateName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {validationErrors.state && (
                                                    <div className="invalid-feedback d-block">
                                                        {validationErrors.state}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        
                                        {/* District Selection */}
                                        {(userLevelValue >= 3) && (
                                            <div className='col-md-4'>
                                                <label className="form-label">District Name</label><label style={{color : "red"}}>*</label>
                                                {userLevelValue === "3" ? (
                                                    // Multiple district selection for District users
                                                    <MultiSelect
                                                        options={districtOptions}
                                                        value={selectedDistricts}
                                                        onChange={handleDistrictChange}
                                                        labelledBy="Select Districts"
                                                        disabled={!stateValue || stateValue === "NA"}
                                                    />
                                                ) : (
                                                    // Single district selection for Surveyor users
                                                    <select 
                                                        className={`form-select ${validationErrors.district ? 'is-invalid' : ''}`}
                                                        value={districtValue[0] || ""}
                                                        onChange={(e) => {
                                                            const selectedDistrictCode = e.target.value;
                                                            setDistrictValue(selectedDistrictCode ? [selectedDistrictCode] : []);
                                                            setSelectedDistricts(selectedDistrictCode ? [{label: districtsData.find(d => d.districtCode.toString() === selectedDistrictCode)?.districtName, value: selectedDistrictCode}] : []);
                                                            
                                                            // Clear blocks and fetch new ones for selected district
                                                            setSelectedBlocks([]);
                                                            setBlockValue([]);
                                                            setBlockOptions([]);
                                                            
                                                            if (selectedDistrictCode) {
                                                                fetchBlocks(selectedDistrictCode);
                                                            }
                                                            
                                                            validateField('district', selectedDistrictCode ? [selectedDistrictCode] : []);
                                                        }}
                                                        disabled={!stateValue || stateValue === "NA"}
                                                    >
                                                        <option value="">Choose...</option>
                                                        {districtsData.map((district, id) => (
                                                            <option key={id} value={district.districtCode}>
                                                                {district.districtName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                                {validationErrors.district && (
                                                    <div style={{color: 'red', fontSize: '0.875em', marginTop: '4px'}}>
                                                        {validationErrors.district}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Block Name - Show for Surveyor only */}
                                        {(userLevelValue === "5") && (
                                            <div className='col-md-4'>
                                                <label className="form-label">Block Name</label><label style={{color : "red"}}>*</label>
                                                <MultiSelect
                                                    options={blockOptions.filter(block => 
                                                        districtValue.length > 0 && districtValue.includes(block.districtCode)
                                                    )}
                                                    value={selectedBlocks}
                                                    onChange={handleBlockChange}
                                                    labelledBy="Select Blocks"
                                                    disabled={districtValue.length === 0}
                                                />
                                                {validationErrors.block && (
                                                    <div style={{color: 'red', fontSize: '0.875em', marginTop: '4px'}}>
                                                        {validationErrors.block}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        

                                        
                                        {/* User Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">User Name</label><label style={{color : "red"}}>*</label>
                                            <input 
                                                placeholder='User Name' 
                                                type='text' 
                                                id='userName'
                                                name='userName_no_autofill'
                                                className={`form-control ${validationErrors.userName ? 'is-invalid' : ''}`}
                                                onChange={(e) => handleUserName(e)} 
                                                value={userNameValue} 
                                                maxLength={50} 
                                                autoComplete="off"
                                                data-lpignore="true"
                                                data-form-type="other"
                                            />
                                            {validationErrors.userName && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.userName}
                                                </div>
                                            )}
                                        </div>
                                        
                                        {/* Designation */}
                                        <div className="col-md-4">
                                            <label htmlFor="Designation" className="form-label">
                                              Designation
                                            </label><label style={{color : "red"}}>*</label>
                                            <select
                                              id="Designation"
                                              required
                                              className={`form-select ${validationErrors.designation ? 'is-invalid' : ''}`}
                                              onChange={handleDesignationChange}
                                              value={designationValue}
                                            >
                                              <option defaultValue>Choose...</option>
                                              {designationData.map((item, id) => {
                                                return (
                                                  <option key={id} value={item.desigCode}>
                                                    {item.desigName}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                            {validationErrors.designation && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.designation}
                                                </div>
                                            )}
                                        </div>
                                        
                                        {/* Mobile No */}
                                        <div className="col-md-4">
                                            <label htmlFor="mobileNo" className="form-label">
                                              Mobile No
                                            </label><label style={{color : "red"}}>*</label>
                                            <input
                                              type="text"
                                              className={`form-control ${validationErrors.mobile ? 'is-invalid' : ''}`}
                                              id="mobilenumber"
                                              required
                                              placeholder="Mobile No."
                                              onChange={(e) => handleMobileNumber(e.target.value)}
                                              value={mobileValue}
                                              onKeyUp={validateMobile}
                                              maxLength="10"
                                              readOnly={state ? true : false}
                                            />
                                            {validationErrors.mobile && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.mobile}
                                                </div>
                                            )}
                                        </div>
                                          {/* Email Id */}
                                        <div className="col-md-4">
                                            <label htmlFor="emailId" className="form-label">
                                              Email Id
                                            </label><label style={{color : "red"}}>*</label>
                                            <input
                                              type="email"
                                              className={`form-control ${validationErrors.email ? 'is-invalid' : ''}`}
                                              id="emailId"
                                              required
                                              placeholder="Email Id"
                                              onChange={handleEmail}
                                              value={emailValue}
                                            />
                                            {validationErrors.email && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.email}
                                                </div>
                                            )}
                                        </div>
                                        {/* Gender */}
                                        <div className="col-md-4">
                                            <div className="col-md-12">
                                              <label htmlFor="gender" className="form-label">
                                                Gender
                                              </label><label style={{color : "red"}}>*</label>
                                            </div>
                                            <div className={`col-md-12 ${validationErrors.gender ? 'is-invalid' : ''}`}>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  handleGenderChange("M");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio1"
                                                  value="male"
                                                  checked={gender === "M"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio1"
                                                >
                                                  Male
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  handleGenderChange("F");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio2"
                                                  value="female"
                                                  checked={gender === "F"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio2"
                                                >
                                                  Female
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  handleGenderChange("T");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio3"
                                                  value="transgender"
                                                  checked={gender === "T"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio3"
                                                >
                                                  Other
                                                </label>
                                              </div>
                                            </div>
                                            {validationErrors.gender && (
                                                <div className="invalid-feedback d-block">
                                                    {validationErrors.gender}
                                                </div>
                                            )}
                                          </div>

                                      
                                    </div>
                                    
                                    {/* Action Buttons */}
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-4">
                                        {state ? (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={ValidateAddUser}
                                          >
                                            Update State User
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={() => {
                                              
                                              ValidateAddUser();
                                            }}
                                          >
                                            Create User
                                          </button>
                                        )}

                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          onClick={() => navigate("/MNT/UsrListMnt")}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <AdminFooterNew /> 
        </>
    );
};
 
export default StateUser; 